import ResponsiveDialog from "../ResponsiveDialog";
import LoginForm from "./login-form";
import TwoFactorLogin from "./two-factor-login";

export type LoginModalProps = {
    loginUser: (event: any) => void;
    handleChangeLoginEmail: (event: any) => void;
    handleChangeLoginPassword: (event: any) => void;
    isLoginPending: boolean;
    email: string;
    password: string;
    handleCreateAccount: () => void;
    handleForgotPassword: () => void;
    handleGoogleLogin: () => void;
    logoSrc: string
    projectScreenshot: string;
    collabMode: boolean;
    imageGraphicItem: any;
    itemType: string;
    projectUrl: string;
    itemDetails: any;
    is2FAEnabled: boolean;
    handleConfirmVerification: (value: string) => void;
    handleResendTwoFa: () => void;
    isMutating: boolean;
    container?: HTMLElement | ShadowRoot | null;
};

export default function LoginModal({
    loginUser,
    handleChangeLoginEmail,
    handleChangeLoginPassword,
    isLoginPending,
    email,
    password,
    handleCreateAccount,
    handleForgotPassword,
    handleGoogleLogin,
    logoSrc,
    itemDetails,
    projectUrl,
    projectScreenshot,
    collabMode,
    imageGraphicItem,
    itemType,
    is2FAEnabled,
    handleConfirmVerification,
    handleResendTwoFa,
    isMutating,
    container
}: LoginModalProps) {

    // const logos = {
    //     hostinger: AtarimHostingerLogo,
    //     basekit: AtarimBasekitLogo,
    // };

    // const logoSrc =
    //     logos[itemDetails?.src as keyof typeof logos] ||
    //     itemDetails?.setting?.whitelabel?.logo;



    return (
        <>
            <ResponsiveDialog.Content
                onEscapeKeyDown={(e) => { e.preventDefault(); }}
                onInteractOutside={(event: { preventDefault: () => any; }) => event.preventDefault()}
                container={container}
                className="w-fit text-textcolor isolate m-auto my-0 max-w-[950px] border-none p-0 z-[99999] bg-transparent min-h-[45dvh] md:min-w-[420px]">
                {/* {itemDetails?.type !== 'graphic' && (
                <Button
                    variant="ghost"
                    size="icon"
                    className='absolute right-5 top-5 text-left text-gray-600'
                // onClick={handleClose}
                >
                    <X color="#ffff" width={18} height={18} />
                </Button>
            )} */}
                <div className="font-roboto">
                    <div className="max-w-[950px] mx-auto shadow-lg overflow-hidden rounded-[18px] bg-gradient-purple md:min-w-[420px]">
                        <div className="flex">
                            <div className="bg-background w-full p-[30px_14px] m-3 rounded-lg">
                                {is2FAEnabled ? (
                                    <TwoFactorLogin
                                        error={error}
                                        handleConfirmVerification={handleConfirmVerification}
                                        handleResendTwoFa={handleResendTwoFa}
                                        isMutating={isMutating}
                                    />
                                ) : (
                                    <div className="text-center bg-background m-4">
                                        <div className='p-0' >
                                            <div className="text-primary flex flex-col items-center pt-8">
                                                <img
                                                    src={logoSrc}
                                                    className="mb-3 inline-flex max-w-[120px]"
                                                    alt="Logo"
                                                />
                                                <div className="flex-grow self-center font-bold text-[17px] text-[#272D3C] mb-3">
                                                    Connect to Collaborate
                                                </div>
                                            </div>
                                        </div>
                                        <LoginForm
                                            loginUser={loginUser}
                                            handleChangeLoginEmail={handleChangeLoginEmail}
                                            handleChangeLoginPassword={handleChangeLoginPassword}
                                            isLoginPending={isLoginPending}
                                            email={email}
                                            password={password}
                                            handleCreateAccount={handleCreateAccount}
                                            handleForgotPassword={handleForgotPassword}
                                            handleGoogleLogin={handleGoogleLogin}
                                        />
                                    </div>
                                )}
                            </div>
                            {/* <AuthRightSideDesign
                                projectScreenshot={projectScreenshot}
                                projectUrl={projectUrl}
                                collabMode={collabMode}
                                imageGraphicItem={imageGraphicItem}
                                itemType={itemType}
                                itemDetails={itemDetails}
                            /> */}
                        </div>
                    </div>
                </div>
            </ResponsiveDialog.Content>
        </>
    );
}